import Plotly from 'plotly.js-dist'
import { getAnnio } from '../service/index'
import { storeAnnio } from '../service/stores'
import { getPlotyAnnio, getPlotyEstado, getPlotyMunicipio, getPlotyPromedio } from '../service/ploty'
let locale = {
    moduleType: "locale",
    name: "es",
    dictionary: {
        Autoscale: "Autoescalar",
        "Box Select": "Seleccionar Caja",
        "Click to enter Colorscale title": "Introducir el t\xedtulo de la Escala de Color",
        "Click to enter Component A title": "Introducir el t\xedtulo del Componente A",
        "Click to enter Component B title": "Introducir el t\xedtulo del Componente B",
        "Click to enter Component C title": "Introducir el t\xedtulo del Componente C",
        "Click to enter Plot title": "Introducir el t\xedtulo de la Gr\xe1fica",
        "Click to enter X axis title": "Introducir el t\xedtulo del eje X",
        "Click to enter Y axis title": "Introducir el t\xedtulo del eje Y",
        "Click to enter radial axis title": "Introducir el t\xedtulo del eje radial",
        "Compare data on hover": "Comparar datos al pasar por encima",
        "Double-click on legend to isolate one trace": "Haga doble-clic en la leyenda para aislar una traza",
        "Double-click to zoom back out": "Haga doble-clic para restaurar la escala",
        "Download plot as a png": "Descargar gr\xe1fica como png",
        "Download plot": "Descargar gr\xe1fica",
        "Edit in Chart Studio": "Editar en Chart Studio",
        "IE only supports svg.  Changing format to svg.": "IE solo soporta svg. Cambiando formato a svg.",
        "Lasso Select": "Seleccionar con lazo",
        "Orbital rotation": "Rotaci\xf3n esf\xe9rica",
        Pan: "Modo Panor\xe1mica",
        "Produced with Plotly": "Hecho con Plotly",
        Reset: "Reiniciar",
        "Reset axes": "Reiniciar ejes",
        "Reset camera to default": "Restaurar c\xe1mara predeterminada",
        "Reset camera to last save": "Restaurar anterior c\xe1mara",
        "Reset view": "Restaurar vista",
        "Reset views": "Restaurar vistas",
        "Show closest data on hover": "Mostrar el dato m\xe1s cercano al pasar por encima",
        "Snapshot succeeded": "La captura de la instant\xe1nea finaliz\xf3 correctamente",
        "Sorry,there was a problem downloading your snapshot!": "\xa1La descarga de la instant\xe1nea fall\xf3!",
        "Taking snapshot - this may take a few seconds": "Capturando una instant\xe1nea - podr\xeda tardar unos segundos",
        "Toggle Spike Lines": "Mostrar/Ocultar Gu\xedas",
        "Toggle show closest data on hover": "Activar/Desactivar mostrar el dato m\xe1s cercano al pasar por encima",
        "Turntable rotation": "Rotaci\xf3n plana",
        Zoom: "Modo Ampliar/Reducir",
        "Zoom in": "Ampliar",
        "Zoom out": "Reducir",
        "close:": "cierre:",
        "high:": "alza:",
        "incoming flow count:": "flujo de entrada:",
        "kde:": "edp:",
        "lat:": "lat:",
        "lon:": "lon:",
        "low:": "baja:",
        "lower fence:": "l\xedmite inferior:",
        "max:": "m\xe1x:",
        "mean \xb1 \u03c3:": "media \xb1 \u03c3:",
        "mean:": "media:",
        "median:": "mediana:",
        "min:": "m\xedn:",
        "new text": "nuevo texto",
        "open:": "apertura:",
        "outgoing flow count:": "flujo de salida:",
        "q1:": "q1:",
        "q3:": "q3:",
        "source:": "fuente:",
        "target:": "destino:",
        trace: "traza",
        "upper fence:": "l\xedmite superior:"
    },
    format: {
        days: ["Domingo","Lunes","Martes","Mi\xe9rcoles","Jueves","Viernes","S\xe1bado"],
        shortDays: ["Dom","Lun","Mar","Mi\xe9","Jue","Vie","S\xe1b"],
        months: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
        shortMonths: ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],
        date: "%d/%m/%Y",
        decimal: ",",
        thousands: " "
    }
};
Plotly.register(locale)
Plotly.setPlotConfig({ locale: 'es' })

let containerPloty=''
export const makePloty = (container) => {
    try {
        containerPloty=container
        const config = {
            displayModeBar: true, // Para mostrar la barra de herramientas
            modeBarButtonsToRemove: ['sendDataToCloud','toImage'], // Eliminar el botón de la cámara
          };
        Plotly.newPlot(
            container,
            [
            {
                x: ['2020-01-01','2020-01-02','2020-01-03','2020-01-04','2020-01-05','2020-01-06','2020-01-07','2020-01-08','2020-01-09','2020-01-10','2020-01-11','2020-01-12','2020-01-13','2020-01-14','2020-01-15','2020-01-16','2020-01-17','2020-01-18','2020-01-19','2020-01-20','2020-01-21','2020-01-22','2020-01-23','2020-01-24','2020-01-25','2020-01-26','2020-01-27','2020-01-28','2020-01-29','2020-01-30','2020-01-31','2020-02-01','2020-02-02','2020-02-03','2020-02-04','2020-02-05','2020-02-06','2020-02-07','2020-02-08','2020-02-09','2020-02-10','2020-02-11','2020-02-12','2020-02-13','2020-02-14','2020-02-15','2020-02-16','2020-02-17','2020-02-18','2020-02-19','2020-02-20','2020-02-21','2020-02-22','2020-02-23','2020-02-24','2020-02-25','2020-02-26','2020-02-27','2020-02-28','2020-02-29','2020-03-01','2020-03-02','2020-03-03','2020-03-04','2020-03-05','2020-03-06','2020-03-07','2020-03-08','2020-03-09','2020-03-10','2020-03-11','2020-03-12','2020-03-13','2020-03-14','2020-03-15','2020-03-16','2020-03-17','2020-03-18','2020-03-19','2020-03-20','2020-03-21','2020-03-22','2020-03-23','2020-03-24','2020-03-25','2020-03-26','2020-03-27','2020-03-28','2020-03-29','2020-03-30','2020-03-31','2020-04-01','2020-04-02','2020-04-03','2020-04-04','2020-04-05','2020-04-06','2020-04-07','2020-04-08','2020-04-09','2020-04-10','2020-04-11','2020-04-12','2020-04-13','2020-04-14','2020-04-15','2020-04-16','2020-04-17','2020-04-18','2020-04-19','2020-04-20','2020-04-21','2020-04-22','2020-04-23','2020-04-24','2020-04-25','2020-04-26','2020-04-27','2020-04-28','2020-04-29','2020-04-30','2020-05-01','2020-05-02','2020-05-03','2020-05-04','2020-05-05','2020-05-06','2020-05-07','2020-05-08','2020-05-09','2020-05-10','2020-05-11','2020-05-12','2020-05-13','2020-05-14','2020-05-15','2020-05-16','2020-05-17','2020-05-18','2020-05-19','2020-05-20','2020-05-21','2020-05-22','2020-05-23','2020-05-24','2020-05-25','2020-05-26','2020-05-27','2020-05-28','2020-05-29','2020-05-30','2020-05-31','2020-06-01','2020-06-02','2020-06-03','2020-06-04','2020-06-05','2020-06-06','2020-06-07','2020-06-08','2020-06-09','2020-06-10','2020-06-11','2020-06-12','2020-06-13','2020-06-14','2020-06-15','2020-06-16','2020-06-17','2020-06-18','2020-06-19','2020-06-20','2020-06-21','2020-06-22','2020-06-23','2020-06-24','2020-06-25','2020-06-26','2020-06-27','2020-06-28','2020-06-29','2020-06-30','2020-07-01','2020-07-02','2020-07-03','2020-07-04','2020-07-05','2020-07-06','2020-07-07','2020-07-08','2020-07-09','2020-07-10','2020-07-11','2020-07-12','2020-07-13','2020-07-14','2020-07-15','2020-07-16','2020-07-17','2020-07-18','2020-07-19','2020-07-20','2020-07-21','2020-07-22','2020-07-23','2020-07-24','2020-07-25','2020-07-26','2020-07-27','2020-07-28','2020-07-29','2020-07-30','2020-07-31','2020-08-01','2020-08-02','2020-08-03','2020-08-04','2020-08-05','2020-08-06','2020-08-07','2020-08-08','2020-08-09','2020-08-10','2020-08-11','2020-08-12','2020-08-13','2020-08-14','2020-08-15','2020-08-16','2020-08-17','2020-08-18','2020-08-19','2020-08-20','2020-08-21','2020-08-22','2020-08-23','2020-08-24','2020-08-25','2020-08-26','2020-08-27','2020-08-28','2020-08-29','2020-08-30','2020-08-31','2020-09-01','2020-09-02','2020-09-03','2020-09-04','2020-09-05','2020-09-06','2020-09-07','2020-09-08','2020-09-09','2020-09-10','2020-09-11','2020-09-12','2020-09-13','2020-09-14','2020-09-15','2020-09-16','2020-09-17','2020-09-18','2020-09-19','2020-09-20','2020-09-21','2020-09-22','2020-09-23','2020-09-24','2020-09-25','2020-09-26','2020-09-27','2020-09-28','2020-09-29','2020-09-30','2020-10-01','2020-10-02','2020-10-03','2020-10-04','2020-10-05','2020-10-06','2020-10-07','2020-10-08','2020-10-09','2020-10-10','2020-10-11','2020-10-12','2020-10-13','2020-10-14','2020-10-15','2020-10-16','2020-10-17','2020-10-18','2020-10-19','2020-10-20','2020-10-21','2020-10-22','2020-10-23','2020-10-24','2020-10-25','2020-10-26','2020-10-27','2020-10-28','2020-10-29','2020-10-30','2020-10-31','2020-11-01','2020-11-02','2020-11-03','2020-11-04','2020-11-05','2020-11-06','2020-11-07','2020-11-08','2020-11-09','2020-11-10','2020-11-11','2020-11-12','2020-11-13','2020-11-14','2020-11-15','2020-11-16','2020-11-17','2020-11-18','2020-11-19','2020-11-20','2020-11-21','2020-11-22','2020-11-23','2020-11-24','2020-11-25','2020-11-26','2020-11-27','2020-11-28','2020-11-29','2020-11-30','2020-12-01','2020-12-02','2020-12-03','2020-12-04','2020-12-05','2020-12-06','2020-12-07','2020-12-08','2020-12-09','2020-12-10','2020-12-11','2020-12-12','2020-12-13','2020-12-14','2020-12-15','2020-12-16','2020-12-17','2020-12-18','2020-12-19','2020-12-20','2020-12-21','2020-12-22','2020-12-23','2020-12-24','2020-12-25','2020-12-26','2020-12-27','2020-12-28','2020-12-29','2020-12-30'],
                y: [13,34.5,98,69.5,93,69.5,79.5,97,109.5,126,102,85,71.5,80.5,35.5,33.5,59.5,74,77.5,56,93.5,114,164,76.5,66,88.5,78,158.5,110,91,62,79.5,31,60.5,55.5,85.5,125.5,91.5,69,42,95,121,126,121.5,60.5,106.5,100,151,113,111,141,97,83.5,104.5,130,102.5,152.5,132,145,156,122,196,123,193.5,70.5,71,126,179.5,152,192,200.5,186.5,371,173.5,107,95,40.5,154.5,118,167.5,144,158.5,297,393,428.5,319.5,549,396,569,279.5,278.5,255.5,227.5,516,409.5,559.5,354,326,397.5,605.5,748.5,854,1253.5,646.5,649.5,521.5,798,765.5,337,907.5,837,1168.5,763,899,1025,731,666,565,840,1046,1034,860.5,875,1032,617,1147.5,1021,1461,1262,1041,1069.5,897,1230,930,1089,1101,1059.5,986.5,870.5,1220.5,998.5,1018,742,686.5,745.5,501.5,658.5,552.5,585,450,228,296,132.5,233,48,245.5,433.5,346,227,294,351.5,187.5,193.5,120.5,181.5,176.5,147,247,144.5,217,152,173,98.5,185.5,152.5,101.5,125,95.5,159.5,77.5,90,106,95.5,80.5,87,51.5,52.5,72.5,37.5,63,61.5,49.5,70,76.5,80,100,69.5,60.5,62,97,70.5,51,66.5,58.5,51,58.5,29.5,50,56,42.5,71.5,68,53,72,53.5,29,60.5,43,51.5,28,29,16,28,48.5,88.5,95,64.5,54.5,50.5,62.5,62.5,70.5,51,27,83,50,89,63.5,32,97,61,82.5,76,75.5,134.5,85.5,85,73.5,74,27,30.5,43,27,23.5,11.5,25.5,29,19,39.5,38,34,64.5,43.5,36,44,47.5,60,38,31.5,34.5,24.5,20,22,57.5,63,65,35.5,57.5,50.5,44,29.5,38,41.5,50,26,34.5,22.5,26,42,29.5,33.5,36,37,66.5,51.5,31,20.5,83,34,41,29,59.5,33.5,30.5,30,13,35,32,56.5,39.5,27.5,45.5,30,53.5,46.5,55,32,46,37.5,31.5,35.5,43,45.5,47,31.5,51.5,36.5,58.5,57,53,67.5,65.5,53.5,66.5,44.5,31,72,70,32.5,49,24.5,27.5,105.5,103.5,99,71.5,42.5,87.5,73.5,76,80.5,60,63.5,27.5,33,38,58,84.5,93,62.5,71,81.5,69,158,127],
                name: 'Media** <br>2004/2022',
                type: 'scatter',
                line: { color: 'red' }
            },
            {
                x: ['2020-01-01','2020-01-02','2020-01-03','2020-01-04','2020-01-05','2020-01-06','2020-01-07','2020-01-08','2020-01-09','2020-01-10','2020-01-11','2020-01-12','2020-01-13','2020-01-14','2020-01-15','2020-01-16','2020-01-17','2020-01-18','2020-01-19','2020-01-20','2020-01-21','2020-01-22','2020-01-23','2020-01-24','2020-01-25','2020-01-26','2020-01-27','2020-01-28','2020-01-29','2020-01-30','2020-01-31','2020-02-01','2020-02-02','2020-02-03','2020-02-04','2020-02-05','2020-02-06','2020-02-07','2020-02-08','2020-02-09','2020-02-10','2020-02-11','2020-02-12','2020-02-13','2020-02-14','2020-02-15','2020-02-16','2020-02-17','2020-02-18','2020-02-19','2020-02-20','2020-02-21','2020-02-22','2020-02-23','2020-02-24','2020-02-25','2020-02-26','2020-02-27','2020-02-28','2020-02-29','2020-03-01','2020-03-02','2020-03-03','2020-03-04','2020-03-05','2020-03-06','2020-03-07','2020-03-08','2020-03-09','2020-03-10','2020-03-11','2020-03-12','2020-03-13','2020-03-14','2020-03-15','2020-03-16','2020-03-17','2020-03-18','2020-03-19','2020-03-20','2020-03-21','2020-03-22','2020-03-23','2020-03-24','2020-03-25','2020-03-26','2020-03-27','2020-03-28','2020-03-29','2020-03-30','2020-03-31','2020-04-01','2020-04-02','2020-04-03','2020-04-04','2020-04-05','2020-04-06','2020-04-07','2020-04-08','2020-04-09','2020-04-10','2020-04-11','2020-04-12','2020-04-13','2020-04-14','2020-04-15','2020-04-16','2020-04-17','2020-04-18','2020-04-19','2020-04-20','2020-04-21','2020-04-22','2020-04-23','2020-04-24','2020-04-25','2020-04-26','2020-04-27','2020-04-28','2020-04-29','2020-04-30','2020-05-01','2020-05-02','2020-05-03','2020-05-04','2020-05-05','2020-05-06','2020-05-07','2020-05-08','2020-05-09','2020-05-10','2020-05-11','2020-05-12','2020-05-13','2020-05-14','2020-05-15','2020-05-16','2020-05-17','2020-05-18','2020-05-19','2020-05-20','2020-05-21','2020-05-22','2020-05-23','2020-05-24','2020-05-25','2020-05-26','2020-05-27','2020-05-28','2020-05-29','2020-05-30','2020-05-31','2020-06-01','2020-06-02','2020-06-03','2020-06-04','2020-06-05','2020-06-06','2020-06-07','2020-06-08','2020-06-09','2020-06-10','2020-06-11','2020-06-12','2020-06-13','2020-06-14','2020-06-15','2020-06-16','2020-06-17','2020-06-18','2020-06-19','2020-06-20','2020-06-21','2020-06-22','2020-06-23','2020-06-24','2020-06-25','2020-06-26','2020-06-27','2020-06-28','2020-06-29','2020-06-30','2020-07-01','2020-07-02','2020-07-03','2020-07-04','2020-07-05','2020-07-06','2020-07-07','2020-07-08','2020-07-09','2020-07-10','2020-07-11','2020-07-12','2020-07-13','2020-07-14','2020-07-15','2020-07-16','2020-07-17','2020-07-18','2020-07-19','2020-07-20','2020-07-21','2020-07-22','2020-07-23','2020-07-24','2020-07-25','2020-07-26','2020-07-27','2020-07-28','2020-07-29','2020-07-30','2020-07-31','2020-08-01','2020-08-02','2020-08-03','2020-08-04','2020-08-05','2020-08-06','2020-08-07','2020-08-08','2020-08-09','2020-08-10','2020-08-11','2020-08-12','2020-08-13','2020-08-14','2020-08-15','2020-08-16','2020-08-17','2020-08-18','2020-08-19','2020-08-20','2020-08-21','2020-08-22','2020-08-23','2020-08-24','2020-08-25','2020-08-26','2020-08-27','2020-08-28','2020-08-29','2020-08-30','2020-08-31','2020-09-01','2020-09-02','2020-09-03','2020-09-04','2020-09-05','2020-09-06','2020-09-07','2020-09-08','2020-09-09','2020-09-10','2020-09-11','2020-09-12','2020-09-13','2020-09-14','2020-09-15','2020-09-16','2020-09-17','2020-09-18','2020-09-19','2020-09-20','2020-09-21','2020-09-22','2020-09-23','2020-09-24','2020-09-25','2020-09-26','2020-09-27','2020-09-28','2020-09-29','2020-09-30','2020-10-01','2020-10-02','2020-10-03','2020-10-04','2020-10-05','2020-10-06','2020-10-07','2020-10-08','2020-10-09','2020-10-10','2020-10-11','2020-10-12','2020-10-13','2020-10-14','2020-10-15','2020-10-16','2020-10-17','2020-10-18','2020-10-19','2020-10-20','2020-10-21','2020-10-22','2020-10-23','2020-10-24','2020-10-25','2020-10-26','2020-10-27','2020-10-28','2020-10-29','2020-10-30','2020-10-31','2020-11-01','2020-11-02','2020-11-03','2020-11-04','2020-11-05','2020-11-06','2020-11-07','2020-11-08','2020-11-09','2020-11-10','2020-11-11','2020-11-12','2020-11-13','2020-11-14','2020-11-15','2020-11-16','2020-11-17','2020-11-18','2020-11-19','2020-11-20','2020-11-21','2020-11-22','2020-11-23','2020-11-24','2020-11-25','2020-11-26','2020-11-27','2020-11-28','2020-11-29','2020-11-30','2020-12-01','2020-12-02','2020-12-03','2020-12-04','2020-12-05','2020-12-06','2020-12-07','2020-12-08','2020-12-09','2020-12-10','2020-12-11','2020-12-12','2020-12-13','2020-12-14','2020-12-15','2020-12-16','2020-12-17','2020-12-18','2020-12-19','2020-12-20','2020-12-21','2020-12-22','2020-12-23','2020-12-24','2020-12-25','2020-12-26','2020-12-27','2020-12-28','2020-12-29','2020-12-30'],
                y: [22,29,82,48,71,98,52,95,85,172,130,67,88,95,40,58,64,48,34,51,38,79,114,49,33,78,99,179,137,45,49,7,18,13,56,64,122,47,48,40,115,166,113,146,49,67,64,107,112,36,120,30,53,49,154,137,103,99,26,149,51,205,117,259,106,21,91,31,54,112,115,112,219,192,97,153,45,210,152,225,151,52,356,309,475,332,562,267,487,259,234,218,100,522,251,621,274,204,543,549,540,671,958,609,842,529,687,658,253,578,371,1014,599,283,1064,521,423,575,826,996,505,785,520,1045,475,1089,750,314,962,259,555,475,770,928,899,1412,1339,1030,441,1109,751,785,570,522,811,324,759,469,560,518,198,498,153,282,25,159,213,132,146,158,459,299,112,110,119,177,130,278,137,238,136,81,75,87,142,15,36,53,114,74,117,149,102,65,41,38,36,53,36,56,58,23,46,112,102,99,52,91,66,87,40,76,88,80,63,63,35,52,47,15,38,59,40,73,37,42,76,57,71,18,28,5,33,9,31,69,32,56,19,66,36,53,51,27,71,22,43,9,25,26,39,53,58,104,155,91,54,21,8,6,21,47,33,34,18,29,49,21,25,38,32,56,23,28,25,51,73,48,19,31,41,29,25,76,90,92,46,77,55,66,36,45,46,60,19,40,34,24,71,55,37,31,67,64,51,50,35,39,36,67,35,68,33,18,35,9,36,37,88,47,19,68,35,85,56,79,61,79,61,36,58,34,41,37,17,38,27,89,54,100,59,97,78,87,82,18,118,46,28,23,18,26,103,138,85,139,42,117,80,78,115,50,93,45,52,59,50,118,75,83,67,130,93,230,127],
                name: '2020',
                type: 'scatter',
                line: { color: '#ffaa00' }
            },
            {
                x: ['2020-01-01','2020-01-02','2020-01-03','2020-01-04','2020-01-05','2020-01-06','2020-01-07','2020-01-08','2020-01-09','2020-01-10','2020-01-11','2020-01-12','2020-01-13','2020-01-14','2020-01-15','2020-01-16','2020-01-17','2020-01-18','2020-01-19','2020-01-20','2020-01-21','2020-01-22','2020-01-23','2020-01-24','2020-01-25','2020-01-26','2020-01-27','2020-01-28','2020-01-29','2020-01-30','2020-01-31','2020-02-01','2020-02-02','2020-02-03','2020-02-04','2020-02-05','2020-02-06','2020-02-07','2020-02-08','2020-02-09','2020-02-10','2020-02-11','2020-02-12','2020-02-13','2020-02-14','2020-02-15','2020-02-16','2020-02-17','2020-02-18','2020-02-19','2020-02-20','2020-02-21','2020-02-22','2020-02-23','2020-02-24','2020-02-25','2020-02-26','2020-02-27','2020-02-28','2020-02-29','2020-03-01','2020-03-02','2020-03-03','2020-03-04','2020-03-05','2020-03-06','2020-03-07','2020-03-08','2020-03-09','2020-03-10','2020-03-11','2020-03-12','2020-03-13','2020-03-14','2020-03-15','2020-03-16','2020-03-17','2020-03-18','2020-03-19','2020-03-20','2020-03-21','2020-03-22','2020-03-23','2020-03-24','2020-03-25','2020-03-26','2020-03-27','2020-03-28','2020-03-29','2020-03-30','2020-03-31','2020-04-01','2020-04-02','2020-04-03','2020-04-04','2020-04-05','2020-04-06','2020-04-07','2020-04-08','2020-04-09','2020-04-10','2020-04-11','2020-04-12','2020-04-13','2020-04-14','2020-04-15','2020-04-16','2020-04-17','2020-04-18','2020-04-19','2020-04-20','2020-04-21','2020-04-22','2020-04-23','2020-04-24','2020-04-25','2020-04-26','2020-04-27','2020-04-28','2020-04-29','2020-04-30','2020-05-01','2020-05-02','2020-05-03','2020-05-04','2020-05-05','2020-05-06','2020-05-07','2020-05-08','2020-05-09','2020-05-10','2020-05-11','2020-05-12','2020-05-13','2020-05-14','2020-05-15','2020-05-16','2020-05-17','2020-05-18','2020-05-19','2020-05-20','2020-05-21','2020-05-22','2020-05-23','2020-05-24','2020-05-25','2020-05-26','2020-05-27','2020-05-28','2020-05-29','2020-05-30','2020-05-31','2020-06-01','2020-06-02','2020-06-03','2020-06-04','2020-06-05','2020-06-06','2020-06-07','2020-06-08','2020-06-09','2020-06-10','2020-06-11','2020-06-12','2020-06-13','2020-06-14','2020-06-15','2020-06-16','2020-06-17','2020-06-18','2020-06-19','2020-06-20','2020-06-21','2020-06-22','2020-06-23','2020-06-24','2020-06-25','2020-06-26','2020-06-27','2020-06-28','2020-06-29','2020-06-30','2020-07-01','2020-07-02','2020-07-03','2020-07-04','2020-07-05','2020-07-06','2020-07-07','2020-07-08','2020-07-09','2020-07-10','2020-07-11','2020-07-12','2020-07-13','2020-07-14','2020-07-15','2020-07-16','2020-07-17','2020-07-18','2020-07-19','2020-07-20','2020-07-21','2020-07-22','2020-07-23','2020-07-24','2020-07-25','2020-07-26','2020-07-27','2020-07-28','2020-07-29','2020-07-30','2020-07-31','2020-08-01','2020-08-02','2020-08-03','2020-08-04','2020-08-05','2020-08-06','2020-08-07','2020-08-08','2020-08-09','2020-08-10','2020-08-11','2020-08-12','2020-08-13','2020-08-14','2020-08-15','2020-08-16','2020-08-17','2020-08-18','2020-08-19','2020-08-20','2020-08-21','2020-08-22','2020-08-23','2020-08-24','2020-08-25','2020-08-26','2020-08-27','2020-08-28','2020-08-29','2020-08-30','2020-08-31','2020-09-01','2020-09-02','2020-09-03','2020-09-04','2020-09-05','2020-09-06','2020-09-07','2020-09-08','2020-09-09','2020-09-10','2020-09-11','2020-09-12','2020-09-13','2020-09-14','2020-09-15','2020-09-16','2020-09-17','2020-09-18','2020-09-19','2020-09-20','2020-09-21','2020-09-22','2020-09-23','2020-09-24','2020-09-25','2020-09-26','2020-09-27','2020-09-28','2020-09-29','2020-09-30','2020-10-01','2020-10-02','2020-10-03','2020-10-04','2020-10-05','2020-10-06','2020-10-07','2020-10-08','2020-10-09','2020-10-10','2020-10-11','2020-10-12','2020-10-13','2020-10-14','2020-10-15','2020-10-16','2020-10-17','2020-10-18','2020-10-19','2020-10-20','2020-10-21','2020-10-22','2020-10-23','2020-10-24','2020-10-25','2020-10-26','2020-10-27','2020-10-28','2020-10-29','2020-10-30','2020-10-31','2020-11-01','2020-11-02','2020-11-03','2020-11-04','2020-11-05','2020-11-06','2020-11-07','2020-11-08','2020-11-09','2020-11-10','2020-11-11','2020-11-12','2020-11-13','2020-11-14','2020-11-15','2020-11-16','2020-11-17','2020-11-18','2020-11-19','2020-11-20','2020-11-21','2020-11-22','2020-11-23','2020-11-24','2020-11-25','2020-11-26','2020-11-27','2020-11-28','2020-11-29','2020-11-30','2020-12-01','2020-12-02','2020-12-03','2020-12-04','2020-12-05','2020-12-06','2020-12-07','2020-12-08','2020-12-09','2020-12-10','2020-12-11','2020-12-12','2020-12-13','2020-12-14','2020-12-15','2020-12-16','2020-12-17','2020-12-18','2020-12-19','2020-12-20','2020-12-21','2020-12-22','2020-12-23','2020-12-24','2020-12-25','2020-12-26','2020-12-27','2020-12-28','2020-12-29','2020-12-30'],
                y: [4,40,114,91,115,41,107,99,134,80,74,103,55,66,31,9,55,100,121,61,149,149,214,104,99,99,57,138,83,137,75,152,44,108,55,107,129,136,90,44,75,76,139,97,72,146,136,195,114,186,162,164,114,160,106,68,202,165,264,163,193,187,129,128,35,121,161,328,250,272,286,261,523,155,117,37,36,99,84,110,137,265,238,477,382,307,536,525,651,300,323,293,355,510,568,498,434,448,252,662,957,1037,1549,684,457,514,909,873,421,1237,1303,1323,927,1515,986,941,909,555,854,1096,1563,936,1230,1019,759,1206,1292,2608,1562,1823,1584,1319,1690,932,1279,790,780,943,1300,1332,1246,1251,914,851,680,679,558,636,610,382,258,94,112,184,71,332,654,560,308,430,244,76,275,131,244,176,164,216,152,196,168,265,122,284,163,188,214,138,205,81,63,63,89,96,133,65,69,92,39,70,65,76,94,41,58,101,87,30,58,107,101,26,45,37,39,54,24,48,65,70,105,77,66,71,70,16,45,29,32,38,30,27,23,88,146,121,97,53,82,59,89,88,51,27,95,78,135,118,39,168,83,112,94,47,114,80,116,126,140,48,40,39,21,13,5,22,9,17,54,38,36,73,64,44,63,44,47,28,44,38,8,11,19,39,36,38,25,38,46,22,23,31,37,40,33,29,11,28,13,4,30,41,7,69,52,12,6,127,32,15,23,51,34,43,25,17,34,27,25,32,36,23,25,22,37,31,3,13,14,27,13,52,50,57,46,65,46,28,60,6,76,34,29,46,7,44,26,94,37,75,31,29,108,69,113,4,43,58,67,74,46,70,34,10,14,17,66,51,111,42,75,33,45,86],
                name: '2019',
                type: 'scatter',
                line: { color: 'grey' }
            }
            ],
            {
                xaxis: {
                    color: 'lightgrey',
                    linecolor: 'dark',
                    autorange: true,
                    tickformat: '%d-%B',
                    rangeslider: { range: ['2020-01-01','2020-12-31'] },
                    type: 'date'
                },
                yaxis: {
                    color: 'lightgrey',
                    autorange: true
                },
                autosize: true,
                width: 550,
                height: 190,
                margin: {
                    l: 60,
                    r: 10,
                    b: 10,
                    t: 20,
                    pad: 7
                },
                paper_bgcolor: '#1c1c1d',
                plot_bgcolor: '#1c1c1d',
                legend: {
                    traceorder: 'normal',
                    font: {
                        family: 'sans-serif',
                        size: 10,
                        color: 'white'
                    },
                    //bgcolor: '#E2E2E2',
                    //bordercolor: '#FFFFFF',
                    opacity: '0.7',
                    //-borderwidth: 1
                }
            },
        config);
        return
    } catch (err) {
        console.log(err)
    }

}
export const updatePloty = async (annioBase,annioComparacion,pais,estado,municipio,opcion,sensor,pcFiltro) => {
    try{
    let promedio=[]
    const isBisiesto = (year) => {
        return (year % 400 === 0) ? true :
                    (year % 100 === 0) ? false :
                        year % 4 === 0;
      };
    Array.prototype.insert = function ( index, item ) {
        this.splice( index, 0, item );
    };
    /*for (let i = 0; i < 365; i++) {
        promedio[i]=(data[`d${annioBase}`][i]+data[`d${annioComparacion}`][i])/2
    }*/
    promedio=[474,725,859,876,941,670,930,766,906,1070,892,770,906,910,622,573,743,777,1075,957,1453,1238,1362,1103,964,1169,1126,1205,919,1124,1108,1048,1053,920,1081,1081,1459,1001,1250,1203,1286,1802,1383,1626,1475,1502,1369,1635,1376,1204,1292,1166,1736,1754,2209,1977,1779,1951,1596,2143,1607,2165,1945,2161,1805,1713,2195,2230,1939,2132,2084,2006,2413,2017,2011,2293,2317,3287,2567,2920,3219,3961,4615,3489,3731,3881,4276,3519,4230,5098,4834,5399,4230,5194,4958,5285,4901,5067,6460,7086,8867,7919,8585,7713,7953,8558,8194,8397,8055,8452,9916,8809,9565,11408,12868,12661,12891,10379,11386,15219,12550,14463,13527,13707,11517,13094,11969,14549,14718,13372,13228,12851,10901,12158,11166,11560,12067,12248,12360,11241,10611,10215,9310,10099,9402,8499,7483,7623,6455,6986,6027,6425,5293,4801,4465,3614,4844,4399,3621,3531,3782,3079,2610,3347,3343,3117,2616,2888,2276,2368,2261,2155,1873,1690,1305,1285,1528,1275,1244,949,964,785,754,821,780,754,628,699,559,625,573,493,570,599,676,640,559,600,654,741,548,609,588,517,534,561,478,598,705,577,597,630,575,744,457,458,497,389,441,398,469,357,591,432,626,635,474,545,451,451,441,551,405,297,482,442,555,407,386,621,398,496,485,429,479,468,441,357,326,331,321,293,387,301,285,250,382,260,293,322,333,439,302,310,335,366,407,345,311,265,244,218,243,328,331,404,317,415,412,359,352,305,315,295,259,358,325,289,350,246,307,315,316,369,349,351,350,450,373,418,389,331,350,347,362,334,338,400,441,397,416,450,372,440,388,539,301,373,453,467,524,510,397,454,364,452,643,666,640,633,631,597,529,737,723,550,734,753,676,653,553,642,880,802,721,564,494,765,794,647,726,718,895,672,590,834,592,684,593,648,695,709,853,646,583,229]
    let infoUpdate={}
    let infoUpdate1={}
    let infoUpdatePromedio={}
    let annioIniSensor=sensor==='modis'?'2004':'2016';
    let annioFinSensor =annioBase-1;

    if(opcion===1){
        let getInfo = await Promise.allSettled([
            getPlotyAnnio({annio:annioBase,pais,sensor,pcFiltro}),
            getPlotyAnnio({annio:annioComparacion,pais,sensor,pcFiltro}),
            getPlotyPromedio({annioIni:annioIniSensor,annioFin:annioFinSensor,pais,estado,municipio,opcion,sensor,pcFiltro})
        ])
        infoUpdate=getInfo[0]['value']
        infoUpdate1=getInfo[1]['value']
        infoUpdatePromedio=getInfo[2]['value']
    }else if(opcion===2){
        let getInfo = await Promise.allSettled([
            getPlotyEstado({annio:annioBase,pais,estado,sensor,pcFiltro}),
            getPlotyEstado({annio:annioComparacion,pais,estado,sensor,pcFiltro}),
            getPlotyPromedio({annioIni:annioIniSensor,annioFin:annioFinSensor,pais,estado,municipio,opcion,sensor,pcFiltro})
        ])
        infoUpdate=getInfo[0]['value']
        infoUpdate1=getInfo[1]['value']
        infoUpdatePromedio=getInfo[2]['value']
    }else if(opcion===3){
        let getInfo = await Promise.allSettled([
            getPlotyMunicipio({annio:annioBase,pais,estado,municipio,sensor,pcFiltro}),
            getPlotyMunicipio({annio:annioComparacion,pais,estado,municipio,sensor,pcFiltro}),
            getPlotyPromedio({annioIni:annioIniSensor,annioFin:annioFinSensor,pais,estado,municipio,opcion,sensor,pcFiltro})
        ])
        infoUpdate=getInfo[0]['value']
        infoUpdate1=getInfo[1]['value']
        infoUpdatePromedio=getInfo[2]['value']
    }

    let baseBisiesto=isBisiesto(infoUpdate['days'][0].substring(0, 4))
    let ComparaBisiesto=isBisiesto(infoUpdate1['days'][0].substring(0, 4))
    let graficaEjeX=[]
    let daysBisiesto=['2020-01-01','2020-01-02','2020-01-03','2020-01-04','2020-01-05','2020-01-06','2020-01-07','2020-01-08','2020-01-09','2020-01-10','2020-01-11','2020-01-12','2020-01-13','2020-01-14','2020-01-15','2020-01-16','2020-01-17','2020-01-18','2020-01-19','2020-01-20','2020-01-21','2020-01-22','2020-01-23','2020-01-24','2020-01-25','2020-01-26','2020-01-27','2020-01-28','2020-01-29','2020-01-30','2020-01-31','2020-02-01','2020-02-02','2020-02-03','2020-02-04','2020-02-05','2020-02-06','2020-02-07','2020-02-08','2020-02-09','2020-02-10','2020-02-11','2020-02-12','2020-02-13','2020-02-14','2020-02-15','2020-02-16','2020-02-17','2020-02-18','2020-02-19','2020-02-20','2020-02-21','2020-02-22','2020-02-23','2020-02-24','2020-02-25','2020-02-26','2020-02-27','2020-02-28','2020-02-29','2020-03-01','2020-03-02','2020-03-03','2020-03-04','2020-03-05','2020-03-06','2020-03-07','2020-03-08','2020-03-09','2020-03-10','2020-03-11','2020-03-12','2020-03-13','2020-03-14','2020-03-15','2020-03-16','2020-03-17','2020-03-18','2020-03-19','2020-03-20','2020-03-21','2020-03-22','2020-03-23','2020-03-24','2020-03-25','2020-03-26','2020-03-27','2020-03-28','2020-03-29','2020-03-30','2020-03-31','2020-04-01','2020-04-02','2020-04-03','2020-04-04','2020-04-05','2020-04-06','2020-04-07','2020-04-08','2020-04-09','2020-04-10','2020-04-11','2020-04-12','2020-04-13','2020-04-14','2020-04-15','2020-04-16','2020-04-17','2020-04-18','2020-04-19','2020-04-20','2020-04-21','2020-04-22','2020-04-23','2020-04-24','2020-04-25','2020-04-26','2020-04-27','2020-04-28','2020-04-29','2020-04-30','2020-05-01','2020-05-02','2020-05-03','2020-05-04','2020-05-05','2020-05-06','2020-05-07','2020-05-08','2020-05-09','2020-05-10','2020-05-11','2020-05-12','2020-05-13','2020-05-14','2020-05-15','2020-05-16','2020-05-17','2020-05-18','2020-05-19','2020-05-20','2020-05-21','2020-05-22','2020-05-23','2020-05-24','2020-05-25','2020-05-26','2020-05-27','2020-05-28','2020-05-29','2020-05-30','2020-05-31','2020-06-01','2020-06-02','2020-06-03','2020-06-04','2020-06-05','2020-06-06','2020-06-07','2020-06-08','2020-06-09','2020-06-10','2020-06-11','2020-06-12','2020-06-13','2020-06-14','2020-06-15','2020-06-16','2020-06-17','2020-06-18','2020-06-19','2020-06-20','2020-06-21','2020-06-22','2020-06-23','2020-06-24','2020-06-25','2020-06-26','2020-06-27','2020-06-28','2020-06-29','2020-06-30','2020-07-01','2020-07-02','2020-07-03','2020-07-04','2020-07-05','2020-07-06','2020-07-07','2020-07-08','2020-07-09','2020-07-10','2020-07-11','2020-07-12','2020-07-13','2020-07-14','2020-07-15','2020-07-16','2020-07-17','2020-07-18','2020-07-19','2020-07-20','2020-07-21','2020-07-22','2020-07-23','2020-07-24','2020-07-25','2020-07-26','2020-07-27','2020-07-28','2020-07-29','2020-07-30','2020-07-31','2020-08-01','2020-08-02','2020-08-03','2020-08-04','2020-08-05','2020-08-06','2020-08-07','2020-08-08','2020-08-09','2020-08-10','2020-08-11','2020-08-12','2020-08-13','2020-08-14','2020-08-15','2020-08-16','2020-08-17','2020-08-18','2020-08-19','2020-08-20','2020-08-21','2020-08-22','2020-08-23','2020-08-24','2020-08-25','2020-08-26','2020-08-27','2020-08-28','2020-08-29','2020-08-30','2020-08-31','2020-09-01','2020-09-02','2020-09-03','2020-09-04','2020-09-05','2020-09-06','2020-09-07','2020-09-08','2020-09-09','2020-09-10','2020-09-11','2020-09-12','2020-09-13','2020-09-14','2020-09-15','2020-09-16','2020-09-17','2020-09-18','2020-09-19','2020-09-20','2020-09-21','2020-09-22','2020-09-23','2020-09-24','2020-09-25','2020-09-26','2020-09-27','2020-09-28','2020-09-29','2020-09-30','2020-10-01','2020-10-02','2020-10-03','2020-10-04','2020-10-05','2020-10-06','2020-10-07','2020-10-08','2020-10-09','2020-10-10','2020-10-11','2020-10-12','2020-10-13','2020-10-14','2020-10-15','2020-10-16','2020-10-17','2020-10-18','2020-10-19','2020-10-20','2020-10-21','2020-10-22','2020-10-23','2020-10-24','2020-10-25','2020-10-26','2020-10-27','2020-10-28','2020-10-29','2020-10-30','2020-10-31','2020-11-01','2020-11-02','2020-11-03','2020-11-04','2020-11-05','2020-11-06','2020-11-07','2020-11-08','2020-11-09','2020-11-10','2020-11-11','2020-11-12','2020-11-13','2020-11-14','2020-11-15','2020-11-16','2020-11-17','2020-11-18','2020-11-19','2020-11-20','2020-11-21','2020-11-22','2020-11-23','2020-11-24','2020-11-25','2020-11-26','2020-11-27','2020-11-28','2020-11-29','2020-11-30','2020-12-01','2020-12-02','2020-12-03','2020-12-04','2020-12-05','2020-12-06','2020-12-07','2020-12-08','2020-12-09','2020-12-10','2020-12-11','2020-12-12','2020-12-13','2020-12-14','2020-12-15','2020-12-16','2020-12-17','2020-12-18','2020-12-19','2020-12-20','2020-12-21','2020-12-22','2020-12-23','2020-12-24','2020-12-25','2020-12-26','2020-12-27','2020-12-28','2020-12-29','2020-12-30','2020-12-31']
    let daysNormal=(data)=>{
        let index=data.findIndex(item => item === item.substring(0, 4)+'-02-29');
        data.splice(index,1)
        return data
    }
    if(baseBisiesto){
        if(!ComparaBisiesto){
            infoUpdate1['totals'].insert(59,0)
        }
        graficaEjeX=daysBisiesto
    }else if(ComparaBisiesto){
        if(!baseBisiesto){
            infoUpdate['totals'].insert(59,0)
        }
        graficaEjeX=daysBisiesto
    }else{
        graficaEjeX=daysNormal(daysBisiesto)
    }
    let update = {
        x: [graficaEjeX],
        y: [infoUpdate['totals']],
        name: annioBase
    }
    let update1 = {
        x: [graficaEjeX],
        y: [infoUpdate1['totals']],
        name: annioComparacion
    }
    let update2 = {
        x: [graficaEjeX],
        y: [infoUpdatePromedio['promedio']],
        name: `Media <br>${annioIniSensor}/${annioFinSensor}`,
    }
    Plotly.restyle(containerPloty,update2,0);
    Plotly.restyle(containerPloty,update,1);
    Plotly.restyle(containerPloty,update1,2);
    return

    }catch(err){
        console.log(err)
    }
}
export const infoPloty = () =>{
    getAnnio()
    return storeAnnio
}
export const infoPloty2 = (annio,id) =>{
    let data=[
        {annio:2004,idedo:'1-0',total:1},
        {annio:2004,idedo:'1-1',total:38},
        {annio:2004,idedo:'1-10',total:608},
        {annio:2004,idedo:'1-11',total:835},
        {annio:2004,idedo:'1-12',total:3966},
        {annio:2004,idedo:'1-13',total:76},
        {annio:2004,idedo:'1-14',total:3447},
        {annio:2004,idedo:'1-15',total:376},
        {annio:2004,idedo:'1-16',total:3851},
        {annio:2004,idedo:'1-17',total:189},
        {annio:2004,idedo:'1-18',total:748},
        {annio:2004,idedo:'1-19',total:165},
        {annio:2004,idedo:'1-2',total:306},
        {annio:2004,idedo:'1-20',total:2335},
        {annio:2004,idedo:'1-21',total:217},
        {annio:2004,idedo:'1-22',total:91},
        {annio:2004,idedo:'1-23',total:501},
        {annio:2004,idedo:'1-24',total:246},
        {annio:2004,idedo:'1-25',total:1167},
        {annio:2004,idedo:'1-26',total:605},
        {annio:2004,idedo:'1-27',total:971},
        {annio:2004,idedo:'1-28',total:728},
        {annio:2004,idedo:'1-29',total:39},
        {annio:2004,idedo:'1-3',total:27},
        {annio:2004,idedo:'1-30',total:1057},
        {annio:2004,idedo:'1-31',total:1997},
        {annio:2004,idedo:'1-32',total:201},
        {annio:2004,idedo:'1-4',total:3233},
        {annio:2004,idedo:'1-5',total:256},
        {annio:2004,idedo:'1-6',total:298},
        {annio:2004,idedo:'1-7',total:3146},
        {annio:2004,idedo:'1-8',total:389},
        {annio:2004,idedo:'1-9',total:46},
        {annio:2005,idedo:'1-0',total:2},
        {annio:2005,idedo:'1-1',total:68},
        {annio:2005,idedo:'1-10',total:2217},
        {annio:2005,idedo:'1-11',total:1190},
        {annio:2005,idedo:'1-12',total:8372},
        {annio:2005,idedo:'1-13',total:204},
        {annio:2005,idedo:'1-14',total:9411},
        {annio:2005,idedo:'1-15',total:758},
        {annio:2005,idedo:'1-16',total:6170},
        {annio:2005,idedo:'1-17',total:274},
        {annio:2005,idedo:'1-18',total:3748},
        {annio:2005,idedo:'1-19',total:268},
        {annio:2005,idedo:'1-2',total:592},
        {annio:2005,idedo:'1-20',total:4688},
        {annio:2005,idedo:'1-21',total:432},
        {annio:2005,idedo:'1-22',total:76},
        {annio:2005,idedo:'1-23',total:1234},
        {annio:2005,idedo:'1-24',total:631},
        {annio:2005,idedo:'1-25',total:1235},
        {annio:2005,idedo:'1-26',total:824},
        {annio:2005,idedo:'1-27',total:2842},
        {annio:2005,idedo:'1-28',total:1283},
        {annio:2005,idedo:'1-29',total:35},
        {annio:2005,idedo:'1-3',total:12},
        {annio:2005,idedo:'1-30',total:3862},
        {annio:2005,idedo:'1-31',total:4755},
        {annio:2005,idedo:'1-32',total:610},
        {annio:2005,idedo:'1-4',total:6966},
        {annio:2005,idedo:'1-5',total:492},
        {annio:2005,idedo:'1-6',total:542},
        {annio:2005,idedo:'1-7',total:6519},
        {annio:2005,idedo:'1-8',total:673},
        {annio:2005,idedo:'1-9',total:33},
        {annio:2006,idedo:'1-0',total:5},
        {annio:2006,idedo:'1-1',total:26},
        {annio:2006,idedo:'1-10',total:2590},
        {annio:2006,idedo:'1-11',total:596},
        {annio:2006,idedo:'1-12',total:4082},
        {annio:2006,idedo:'1-13',total:171},
        {annio:2006,idedo:'1-14',total:3365},
        {annio:2006,idedo:'1-15',total:747},
        {annio:2006,idedo:'1-16',total:4951},
        {annio:2006,idedo:'1-17',total:277},
        {annio:2006,idedo:'1-18',total:1094},
        {annio:2006,idedo:'1-19',total:431},
        {annio:2006,idedo:'1-2',total:463},
        {annio:2006,idedo:'1-20',total:2595},
        {annio:2006,idedo:'1-21',total:362},
        {annio:2006,idedo:'1-22',total:57},
        {annio:2006,idedo:'1-23',total:2378},
        {annio:2006,idedo:'1-24',total:613},
        {annio:2006,idedo:'1-25',total:1571},
        {annio:2006,idedo:'1-26',total:747},
        {annio:2006,idedo:'1-27',total:1030},
        {annio:2006,idedo:'1-28',total:1478},
        {annio:2006,idedo:'1-29',total:71},
        {annio:2006,idedo:'1-3',total:9},
        {annio:2006,idedo:'1-30',total:2506},
        {annio:2006,idedo:'1-31',total:3806},
        {annio:2006,idedo:'1-32',total:221},
        {annio:2006,idedo:'1-4',total:5100},
        {annio:2006,idedo:'1-5',total:610},
        {annio:2006,idedo:'1-6',total:334},
        {annio:2006,idedo:'1-7',total:3576},
        {annio:2006,idedo:'1-8',total:1741},
        {annio:2006,idedo:'1-9',total:56},
        {annio:2007,idedo:'1-0',total:2},
        {annio:2007,idedo:'1-1',total:34},
        {annio:2007,idedo:'1-10',total:2066},
        {annio:2007,idedo:'1-11',total:638},
        {annio:2007,idedo:'1-12',total:5700},
        {annio:2007,idedo:'1-13',total:170},
        {annio:2007,idedo:'1-14',total:3452},
        {annio:2007,idedo:'1-15',total:432},
        {annio:2007,idedo:'1-16',total:4552},
        {annio:2007,idedo:'1-17',total:177},
        {annio:2007,idedo:'1-18',total:1297},
        {annio:2007,idedo:'1-19',total:263},
        {annio:2007,idedo:'1-2',total:301},
        {annio:2007,idedo:'1-20',total:2866},
        {annio:2007,idedo:'1-21',total:247},
        {annio:2007,idedo:'1-22',total:63},
        {annio:2007,idedo:'1-23',total:489},
        {annio:2007,idedo:'1-24',total:223},
        {annio:2007,idedo:'1-25',total:1527},
        {annio:2007,idedo:'1-26',total:898},
        {annio:2007,idedo:'1-27',total:2138},
        {annio:2007,idedo:'1-28',total:502},
        {annio:2007,idedo:'1-29',total:19},
        {annio:2007,idedo:'1-3',total:14},
        {annio:2007,idedo:'1-30',total:1965},
        {annio:2007,idedo:'1-31',total:2394},
        {annio:2007,idedo:'1-32',total:312},
        {annio:2007,idedo:'1-4',total:4482},
        {annio:2007,idedo:'1-5',total:396},
        {annio:2007,idedo:'1-6',total:311},
        {annio:2007,idedo:'1-7',total:4693},
        {annio:2007,idedo:'1-8',total:1309},
        {annio:2007,idedo:'1-9',total:26},
        {annio:2008,idedo:'1-0',total:3},
        {annio:2008,idedo:'1-1',total:51},
        {annio:2008,idedo:'1-10',total:3546},
        {annio:2008,idedo:'1-11',total:1006},
        {annio:2008,idedo:'1-12',total:4267},
        {annio:2008,idedo:'1-13',total:227},
        {annio:2008,idedo:'1-14',total:3951},
        {annio:2008,idedo:'1-15',total:462},
        {annio:2008,idedo:'1-16',total:4378},
        {annio:2008,idedo:'1-17',total:203},
        {annio:2008,idedo:'1-18',total:1045},
        {annio:2008,idedo:'1-19',total:561},
        {annio:2008,idedo:'1-2',total:316},
        {annio:2008,idedo:'1-20',total:3201},
        {annio:2008,idedo:'1-21',total:359},
        {annio:2008,idedo:'1-22',total:127},
        {annio:2008,idedo:'1-23',total:1088},
        {annio:2008,idedo:'1-24',total:494},
        {annio:2008,idedo:'1-25',total:1414},
        {annio:2008,idedo:'1-26',total:712},
        {annio:2008,idedo:'1-27',total:734},
        {annio:2008,idedo:'1-28',total:1299},
        {annio:2008,idedo:'1-29',total:24},
        {annio:2008,idedo:'1-3',total:10},
        {annio:2008,idedo:'1-30',total:1883},
        {annio:2008,idedo:'1-31',total:1934},
        {annio:2008,idedo:'1-32',total:485},
        {annio:2008,idedo:'1-4',total:4321},
        {annio:2008,idedo:'1-5',total:824},
        {annio:2008,idedo:'1-6',total:310},
        {annio:2008,idedo:'1-7',total:3167},
        {annio:2008,idedo:'1-8',total:1493},
        {annio:2008,idedo:'1-9',total:48},
        {annio:2009,idedo:'1-0',total:3},
        {annio:2009,idedo:'1-1',total:17},
        {annio:2009,idedo:'1-10',total:987},
        {annio:2009,idedo:'1-11',total:515},
        {annio:2009,idedo:'1-12',total:4266},
        {annio:2009,idedo:'1-13',total:327},
        {annio:2009,idedo:'1-14',total:3456},
        {annio:2009,idedo:'1-15',total:601},
        {annio:2009,idedo:'1-16',total:4516},
        {annio:2009,idedo:'1-17',total:195},
        {annio:2009,idedo:'1-18',total:987},
        {annio:2009,idedo:'1-19',total:443},
        {annio:2009,idedo:'1-2',total:801},
        {annio:2009,idedo:'1-20',total:2371},
        {annio:2009,idedo:'1-21',total:435},
        {annio:2009,idedo:'1-22',total:88},
        {annio:2009,idedo:'1-23',total:1402},
        {annio:2009,idedo:'1-24',total:525},
        {annio:2009,idedo:'1-25',total:970},
        {annio:2009,idedo:'1-26',total:717},
        {annio:2009,idedo:'1-27',total:1921},
        {annio:2009,idedo:'1-28',total:1892},
        {annio:2009,idedo:'1-29',total:102},
        {annio:2009,idedo:'1-3',total:14},
        {annio:2009,idedo:'1-30',total:2247},
        {annio:2009,idedo:'1-31',total:4143},
        {annio:2009,idedo:'1-32',total:417},
        {annio:2009,idedo:'1-4',total:5425},
        {annio:2009,idedo:'1-5',total:560},
        {annio:2009,idedo:'1-6',total:270},
        {annio:2009,idedo:'1-7',total:4211},
        {annio:2009,idedo:'1-8',total:1418},
        {annio:2009,idedo:'1-9',total:81},
        {annio:2010,idedo:'1-0',total:1},
        {annio:2010,idedo:'1-1',total:30},
        {annio:2010,idedo:'1-10',total:692},
        {annio:2010,idedo:'1-11',total:470},
        {annio:2010,idedo:'1-12',total:4005},
        {annio:2010,idedo:'1-13',total:227},
        {annio:2010,idedo:'1-14',total:2624},
        {annio:2010,idedo:'1-15',total:522},
        {annio:2010,idedo:'1-16',total:3672},
        {annio:2010,idedo:'1-17',total:160},
        {annio:2010,idedo:'1-18',total:682},
        {annio:2010,idedo:'1-19',total:357},
        {annio:2010,idedo:'1-2',total:311},
        {annio:2010,idedo:'1-20',total:2417},
        {annio:2010,idedo:'1-21',total:262},
        {annio:2010,idedo:'1-22',total:82},
        {annio:2010,idedo:'1-23',total:485},
        {annio:2010,idedo:'1-24',total:303},
        {annio:2010,idedo:'1-25',total:1283},
        {annio:2010,idedo:'1-26',total:601},
        {annio:2010,idedo:'1-27',total:985},
        {annio:2010,idedo:'1-28',total:1079},
        {annio:2010,idedo:'1-29',total:32},
        {annio:2010,idedo:'1-3',total:21},
        {annio:2010,idedo:'1-30',total:1204},
        {annio:2010,idedo:'1-31',total:1641},
        {annio:2010,idedo:'1-32',total:121},
        {annio:2010,idedo:'1-4',total:2952},
        {annio:2010,idedo:'1-5',total:668},
        {annio:2010,idedo:'1-6',total:248},
        {annio:2010,idedo:'1-7',total:3269},
        {annio:2010,idedo:'1-8',total:1273},
        {annio:2010,idedo:'1-9',total:47},
        {annio:2011,idedo:'1-0',total:1},
        {annio:2011,idedo:'1-1',total:14},
        {annio:2011,idedo:'1-10',total:6256},
        {annio:2011,idedo:'1-11',total:421},
        {annio:2011,idedo:'1-12',total:79},
        {annio:2011,idedo:'1-12',total:4892},
        {annio:2011,idedo:'1-13',total:1},
        {annio:2011,idedo:'1-13',total:429},
        {annio:2011,idedo:'1-14',total:36},
        {annio:2011,idedo:'1-14',total:4700},
        {annio:2011,idedo:'1-15',total:817},
        {annio:2011,idedo:'1-15',total:9},
        {annio:2011,idedo:'1-16',total:5036},
        {annio:2011,idedo:'1-16',total:71},
        {annio:2011,idedo:'1-17',total:168},
        {annio:2011,idedo:'1-18',total:1810},
        {annio:2011,idedo:'1-19',total:1539},
        {annio:2011,idedo:'1-2',total:316},
        {annio:2011,idedo:'1-20',total:30},
        {annio:2011,idedo:'1-20',total:2986},
        {annio:2011,idedo:'1-21',total:586},
        {annio:2011,idedo:'1-22',total:1},
        {annio:2011,idedo:'1-22',total:110},
        {annio:2011,idedo:'1-23',total:2536},
        {annio:2011,idedo:'1-24',total:936},
        {annio:2011,idedo:'1-25',total:1836},
        {annio:2011,idedo:'1-26',total:3461},
        {annio:2011,idedo:'1-27',total:1216},
        {annio:2011,idedo:'1-28',total:2916},
        {annio:2011,idedo:'1-29',total:54},
        {annio:2011,idedo:'1-3',total:12},
        {annio:2011,idedo:'1-30',total:1},
        {annio:2011,idedo:'1-30',total:2874},
        {annio:2011,idedo:'1-31',total:3999},
        {annio:2011,idedo:'1-32',total:448},
        {annio:2011,idedo:'1-4',total:5402},
        {annio:2011,idedo:'1-5',total:8721},
        {annio:2011,idedo:'1-6',total:1},
        {annio:2011,idedo:'1-6',total:279},
        {annio:2011,idedo:'1-7',total:4037},
        {annio:2011,idedo:'1-8',total:6699},
        {annio:2011,idedo:'1-9',total:105},
        {annio:2012,idedo:'1-0',total:4},
        {annio:2012,idedo:'1-1',total:24},
        {annio:2012,idedo:'1-10',total:3046},
        {annio:2012,idedo:'1-11',total:213},
        {annio:2012,idedo:'1-12',total:5180},
        {annio:2012,idedo:'1-13',total:193},
        {annio:2012,idedo:'1-14',total:3505},
        {annio:2012,idedo:'1-15',total:528},
        {annio:2012,idedo:'1-16',total:5285},
        {annio:2012,idedo:'1-17',total:202},
        {annio:2012,idedo:'1-18',total:1552},
        {annio:2012,idedo:'1-19',total:148},
        {annio:2012,idedo:'1-2',total:346},
        {annio:2012,idedo:'1-20',total:3528},
        {annio:2012,idedo:'1-21',total:207},
        {annio:2012,idedo:'1-22',total:60},
        {annio:2012,idedo:'1-23',total:358},
        {annio:2012,idedo:'1-24',total:342},
        {annio:2012,idedo:'1-25',total:2029},
        {annio:2012,idedo:'1-26',total:1632},
        {annio:2012,idedo:'1-27',total:1215},
        {annio:2012,idedo:'1-28',total:804},
        {annio:2012,idedo:'1-29',total:16},
        {annio:2012,idedo:'1-3',total:30},
        {annio:2012,idedo:'1-30',total:1667},
        {annio:2012,idedo:'1-31',total:1029},
        {annio:2012,idedo:'1-32',total:138},
        {annio:2012,idedo:'1-4',total:3464},
        {annio:2012,idedo:'1-5',total:1057},
        {annio:2012,idedo:'1-6',total:296},
        {annio:2012,idedo:'1-7',total:4503},
        {annio:2012,idedo:'1-8',total:2517},
        {annio:2012,idedo:'1-9',total:30},
        {annio:2013,idedo:'1-0',total:2},
        {annio:2013,idedo:'1-1',total:23},
        {annio:2013,idedo:'1-10',total:1175},
        {annio:2013,idedo:'1-11',total:327},
        {annio:2013,idedo:'1-12',total:6036},
        {annio:2013,idedo:'1-13',total:229},
        {annio:2013,idedo:'1-14',total:3867},
        {annio:2013,idedo:'1-15',total:681},
        {annio:2013,idedo:'1-16',total:4582},
        {annio:2013,idedo:'1-17',total:207},
        {annio:2013,idedo:'1-18',total:1203},
        {annio:2013,idedo:'1-19',total:208},
        {annio:2013,idedo:'1-2',total:333},
        {annio:2013,idedo:'1-20',total:4172},
        {annio:2013,idedo:'1-21',total:376},
        {annio:2013,idedo:'1-22',total:77},
        {annio:2013,idedo:'1-23',total:1409},
        {annio:2013,idedo:'1-24',total:661},
        {annio:2013,idedo:'1-25',total:1},
        {annio:2013,idedo:'1-25',total:1768},
        {annio:2013,idedo:'1-26',total:2027},
        {annio:2013,idedo:'1-27',total:2046},
        {annio:2013,idedo:'1-28',total:1308},
        {annio:2013,idedo:'1-29',total:40},
        {annio:2013,idedo:'1-3',total:56},
        {annio:2013,idedo:'1-30',total:2851},
        {annio:2013,idedo:'1-31',total:3767},
        {annio:2013,idedo:'1-32',total:120},
        {annio:2013,idedo:'1-4',total:6694},
        {annio:2013,idedo:'1-5',total:571},
        {annio:2013,idedo:'1-6',total:359},
        {annio:2013,idedo:'1-7',total:58},
        {annio:2013,idedo:'1-7',total:6060},
        {annio:2013,idedo:'1-8',total:1677},
        {annio:2013,idedo:'1-9',total:51},
        {annio:2014,idedo:'1-0',total:7},
        {annio:2014,idedo:'1-1',total:35},
        {annio:2014,idedo:'1-10',total:786},
        {annio:2014,idedo:'1-11',total:606},
        {annio:2014,idedo:'1-12',total:2100},
        {annio:2014,idedo:'1-13',total:169},
        {annio:2014,idedo:'1-14',total:1752},
        {annio:2014,idedo:'1-15',total:380},
        {annio:2014,idedo:'1-16',total:3227},
        {annio:2014,idedo:'1-17',total:297},
        {annio:2014,idedo:'1-18',total:384},
        {annio:2014,idedo:'1-19',total:206},
        {annio:2014,idedo:'1-2',total:286},
        {annio:2014,idedo:'1-20',total:2257},
        {annio:2014,idedo:'1-21',total:326},
        {annio:2014,idedo:'1-22',total:119},
        {annio:2014,idedo:'1-23',total:329},
        {annio:2014,idedo:'1-24',total:353},
        {annio:2014,idedo:'1-25',total:1116},
        {annio:2014,idedo:'1-26',total:1255},
        {annio:2014,idedo:'1-27',total:1257},
        {annio:2014,idedo:'1-28',total:820},
        {annio:2014,idedo:'1-29',total:18},
        {annio:2014,idedo:'1-3',total:56},
        {annio:2014,idedo:'1-30',total:1791},
        {annio:2014,idedo:'1-31',total:2738},
        {annio:2014,idedo:'1-32',total:169},
        {annio:2014,idedo:'1-4',total:2766},
        {annio:2014,idedo:'1-5',total:742},
        {annio:2014,idedo:'1-6',total:314},
        {annio:2014,idedo:'1-7',total:3324},
        {annio:2014,idedo:'1-8',total:1475},
        {annio:2014,idedo:'1-9',total:34},
        {annio:2015,idedo:'1-0',total:4},
        {annio:2015,idedo:'1-1',total:44},
        {annio:2015,idedo:'1-10',total:375},
        {annio:2015,idedo:'1-11',total:688},
        {annio:2015,idedo:'1-12',total:4788},
        {annio:2015,idedo:'1-13',total:146},
        {annio:2015,idedo:'1-14',total:2129},
        {annio:2015,idedo:'1-15',total:492},
        {annio:2015,idedo:'1-16',total:3784},
        {annio:2015,idedo:'1-17',total:159},
        {annio:2015,idedo:'1-18',total:540},
        {annio:2015,idedo:'1-19',total:302},
        {annio:2015,idedo:'1-2',total:301},
        {annio:2015,idedo:'1-20',total:2374},
        {annio:2015,idedo:'1-21',total:189},
        {annio:2015,idedo:'1-22',total:162},
        {annio:2015,idedo:'1-23',total:1438},
        {annio:2015,idedo:'1-24',total:284},
        {annio:2015,idedo:'1-25',total:1133},
        {annio:2015,idedo:'1-26',total:665},
        {annio:2015,idedo:'1-27',total:2035},
        {annio:2015,idedo:'1-28',total:639},
        {annio:2015,idedo:'1-29',total:25},
        {annio:2015,idedo:'1-3',total:87},
        {annio:2015,idedo:'1-30',total:1758},
        {annio:2015,idedo:'1-31',total:3278},
        {annio:2015,idedo:'1-32',total:128},
        {annio:2015,idedo:'1-4',total:4565},
        {annio:2015,idedo:'1-5',total:644},
        {annio:2015,idedo:'1-6',total:308},
        {annio:2015,idedo:'1-7',total:4307},
        {annio:2015,idedo:'1-8',total:719},
        {annio:2015,idedo:'1-9',total:30},
        {annio:2016,idedo:'1-0',total:1},
        {annio:2016,idedo:'1-0',total:5},
        {annio:2016,idedo:'1-1',total:3},
        {annio:2016,idedo:'1-1',total:80},
        {annio:2016,idedo:'1-10',total:16},
        {annio:2016,idedo:'1-10',total:1220},
        {annio:2016,idedo:'1-11',total:259},
        {annio:2016,idedo:'1-11',total:685},
        {annio:2016,idedo:'1-12',total:94},
        {annio:2016,idedo:'1-12',total:4069},
        {annio:2016,idedo:'1-13',total:6},
        {annio:2016,idedo:'1-13',total:219},
        {annio:2016,idedo:'1-14',total:146},
        {annio:2016,idedo:'1-14',total:5423},
        {annio:2016,idedo:'1-15',total:652},
        {annio:2016,idedo:'1-15',total:16},
        {annio:2016,idedo:'1-16',total:4133},
        {annio:2016,idedo:'1-16',total:260},
        {annio:2016,idedo:'1-17',total:37},
        {annio:2016,idedo:'1-17',total:145},
        {annio:2016,idedo:'1-18',total:26},
        {annio:2016,idedo:'1-18',total:1399},
        {annio:2016,idedo:'1-19',total:339},
        {annio:2016,idedo:'1-19',total:33},
        {annio:2016,idedo:'1-2',total:32},
        {annio:2016,idedo:'1-2',total:210},
        {annio:2016,idedo:'1-20',total:166},
        {annio:2016,idedo:'1-20',total:2954},
        {annio:2016,idedo:'1-21',total:20},
        {annio:2016,idedo:'1-21',total:337},
        {annio:2016,idedo:'1-22',total:23},
        {annio:2016,idedo:'1-22',total:250},
        {annio:2016,idedo:'1-23',total:27},
        {annio:2016,idedo:'1-23',total:534},
        {annio:2016,idedo:'1-24',total:437},
        {annio:2016,idedo:'1-24',total:21},
        {annio:2016,idedo:'1-25',total:32},
        {annio:2016,idedo:'1-25',total:1401},
        {annio:2016,idedo:'1-26',total:108},
        {annio:2016,idedo:'1-26',total:1228},
        {annio:2016,idedo:'1-27',total:193},
        {annio:2016,idedo:'1-27',total:1954},
        {annio:2016,idedo:'1-28',total:95},
        {annio:2016,idedo:'1-28',total:1218},
        {annio:2016,idedo:'1-29',total:55},
        {annio:2016,idedo:'1-3',total:4},
        {annio:2016,idedo:'1-3',total:42},
        {annio:2016,idedo:'1-30',total:131},
        {annio:2016,idedo:'1-30',total:2617},
        {annio:2016,idedo:'1-31',total:1764},
        {annio:2016,idedo:'1-31',total:32},
        {annio:2016,idedo:'1-32',total:18},
        {annio:2016,idedo:'1-32',total:418},
        {annio:2016,idedo:'1-4',total:52},
        {annio:2016,idedo:'1-4',total:4416},
        {annio:2016,idedo:'1-5',total:99},
        {annio:2016,idedo:'1-5',total:600},
        {annio:2016,idedo:'1-6',total:55},
        {annio:2016,idedo:'1-6',total:464},
        {annio:2016,idedo:'1-7',total:162},
        {annio:2016,idedo:'1-7',total:4119},
        {annio:2016,idedo:'1-8',total:232},
        {annio:2016,idedo:'1-8',total:1811},
        {annio:2016,idedo:'1-9',total:1},
        {annio:2016,idedo:'1-9',total:25},
        {annio:2017,idedo:'1-1',total:141},
        {annio:2017,idedo:'1-10',total:2700},
        {annio:2017,idedo:'1-11',total:1103},
        {annio:2017,idedo:'1-12',total:7714},
        {annio:2017,idedo:'1-13',total:268},
        {annio:2017,idedo:'1-14',total:8182},
        {annio:2017,idedo:'1-15',total:1032},
        {annio:2017,idedo:'1-16',total:5411},
        {annio:2017,idedo:'1-17',total:408},
        {annio:2017,idedo:'1-18',total:2570},
        {annio:2017,idedo:'1-19',total:443},
        {annio:2017,idedo:'1-2',total:598},
        {annio:2017,idedo:'1-20',total:4167},
        {annio:2017,idedo:'1-21',total:666},
        {annio:2017,idedo:'1-22',total:215},
        {annio:2017,idedo:'1-23',total:1390},
        {annio:2017,idedo:'1-24',total:708},
        {annio:2017,idedo:'1-25',total:1777},
        {annio:2017,idedo:'1-26',total:2396},
        {annio:2017,idedo:'1-27',total:3462},
        {annio:2017,idedo:'1-28',total:1559},
        {annio:2017,idedo:'1-29',total:137},
        {annio:2017,idedo:'1-3',total:30},
        {annio:2017,idedo:'1-30',total:2838},
        {annio:2017,idedo:'1-31',total:3000},
        {annio:2017,idedo:'1-32',total:715},
        {annio:2017,idedo:'1-4',total:7434},
        {annio:2017,idedo:'1-5',total:878},
        {annio:2017,idedo:'1-6',total:449},
        {annio:2017,idedo:'1-7',total:5340},
        {annio:2017,idedo:'1-8',total:3163},
        {annio:2017,idedo:'1-9',total:66},
        {annio:2018,idedo:'1-1',total:90},
        {annio:2018,idedo:'1-10',total:1683},
        {annio:2018,idedo:'1-11',total:839},
        {annio:2018,idedo:'1-12',total:5068},
        {annio:2018,idedo:'1-13',total:117},
        {annio:2018,idedo:'1-14',total:3213},
        {annio:2018,idedo:'1-15',total:453},
        {annio:2018,idedo:'1-16',total:3734},
        {annio:2018,idedo:'1-17',total:153},
        {annio:2018,idedo:'1-18',total:1280},
        {annio:2018,idedo:'1-19',total:465},
        {annio:2018,idedo:'1-2',total:506},
        {annio:2018,idedo:'1-20',total:2738},
        {annio:2018,idedo:'1-21',total:294},
        {annio:2018,idedo:'1-22',total:152},
        {annio:2018,idedo:'1-23',total:610},
        {annio:2018,idedo:'1-24',total:525},
        {annio:2018,idedo:'1-25',total:1553},
        {annio:2018,idedo:'1-26',total:1384},
        {annio:2018,idedo:'1-27',total:3232},
        {annio:2018,idedo:'1-28',total:1005},
        {annio:2018,idedo:'1-29',total:34},
        {annio:2018,idedo:'1-3',total:26},
        {annio:2018,idedo:'1-30',total:2069},
        {annio:2018,idedo:'1-31',total:1532},
        {annio:2018,idedo:'1-32',total:294},
        {annio:2018,idedo:'1-4',total:3580},
        {annio:2018,idedo:'1-5',total:1038},
        {annio:2018,idedo:'1-6',total:313},
        {annio:2018,idedo:'1-7',total:4930},
        {annio:2018,idedo:'1-8',total:3744},
        {annio:2018,idedo:'1-9',total:39},
        {annio:2019,idedo:'1-1',total:166},
        {annio:2019,idedo:'1-10',total:2725},
        {annio:2019,idedo:'1-11',total:1384},
        {annio:2019,idedo:'1-12',total:10236},
        {annio:2019,idedo:'1-13',total:355},
        {annio:2019,idedo:'1-14',total:5762},
        {annio:2019,idedo:'1-15',total:1098},
        {annio:2019,idedo:'1-16',total:5874},
        {annio:2019,idedo:'1-17',total:373},
        {annio:2019,idedo:'1-18',total:1766},
        {annio:2019,idedo:'1-19',total:488},
        {annio:2019,idedo:'1-2',total:373},
        {annio:2019,idedo:'1-20',total:6514},
        {annio:2019,idedo:'1-21',total:864},
        {annio:2019,idedo:'1-22',total:251},
        {annio:2019,idedo:'1-23',total:2242},
        {annio:2019,idedo:'1-24',total:1304},
        {annio:2019,idedo:'1-25',total:1856},
        {annio:2019,idedo:'1-26',total:1085},
        {annio:2019,idedo:'1-27',total:6500},
        {annio:2019,idedo:'1-28',total:1467},
        {annio:2019,idedo:'1-29',total:108},
        {annio:2019,idedo:'1-3',total:32},
        {annio:2019,idedo:'1-30',total:5123},
        {annio:2019,idedo:'1-31',total:4316},
        {annio:2019,idedo:'1-32',total:530},
        {annio:2019,idedo:'1-4',total:9950},
        {annio:2019,idedo:'1-5',total:875},
        {annio:2019,idedo:'1-6',total:443},
        {annio:2019,idedo:'1-7',total:11469},
        {annio:2019,idedo:'1-8',total:1596},
        {annio:2019,idedo:'1-9',total:83},
        {annio:2020,idedo:'1-1',total:77},
        {annio:2020,idedo:'1-10',total:655},
        {annio:2020,idedo:'1-11',total:1234},
        {annio:2020,idedo:'1-12',total:9453},
        {annio:2020,idedo:'1-13',total:228},
        {annio:2020,idedo:'1-14',total:4008},
        {annio:2020,idedo:'1-15',total:823},
        {annio:2020,idedo:'1-16',total:6006},
        {annio:2020,idedo:'1-17',total:377},
        {annio:2020,idedo:'1-18',total:937},
        {annio:2020,idedo:'1-19',total:528},
        {annio:2020,idedo:'1-2',total:910},
        {annio:2020,idedo:'1-20',total:3522},
        {annio:2020,idedo:'1-21',total:555},
        {annio:2020,idedo:'1-22',total:146},
        {annio:2020,idedo:'1-23',total:1709},
        {annio:2020,idedo:'1-24',total:482},
        {annio:2020,idedo:'1-25',total:1387},
        {annio:2020,idedo:'1-26',total:1026},
        {annio:2020,idedo:'1-27',total:4062},
        {annio:2020,idedo:'1-28',total:1451},
        {annio:2020,idedo:'1-29',total:122},
        {annio:2020,idedo:'1-3',total:57},
        {annio:2020,idedo:'1-30',total:3100},
        {annio:2020,idedo:'1-31',total:3001},
        {annio:2020,idedo:'1-32',total:205},
        {annio:2020,idedo:'1-4',total:8708},
        {annio:2020,idedo:'1-5',total:531},
        {annio:2020,idedo:'1-6',total:436},
        {annio:2020,idedo:'1-7',total:7106},
        {annio:2020,idedo:'1-8',total:1108},
        {annio:2020,idedo:'1-9',total:51},
        {annio:2021,idedo:'1-1',total:62},
        {annio:2021,idedo:'1-10',total:1751},
        {annio:2021,idedo:'1-11',total:754},
        {annio:2021,idedo:'1-12',total:5521},
        {annio:2021,idedo:'1-13',total:199},
        {annio:2021,idedo:'1-14',total:4574},
        {annio:2021,idedo:'1-15',total:760},
        {annio:2021,idedo:'1-16',total:4913},
        {annio:2021,idedo:'1-17',total:267},
        {annio:2021,idedo:'1-18',total:1595},
        {annio:2021,idedo:'1-19',total:973},
        {annio:2021,idedo:'1-2',total:468},
        {annio:2021,idedo:'1-20',total:3167},
        {annio:2021,idedo:'1-21',total:462},
        {annio:2021,idedo:'1-22',total:138},
        {annio:2021,idedo:'1-23',total:548},
        {annio:2021,idedo:'1-24',total:687},
        {annio:2021,idedo:'1-25',total:1549},
        {annio:2021,idedo:'1-26',total:1065},
        {annio:2021,idedo:'1-27',total:3317},
        {annio:2021,idedo:'1-28',total:1636},
        {annio:2021,idedo:'1-29',total:85},
        {annio:2021,idedo:'1-3',total:81},
        {annio:2021,idedo:'1-30',total:3029},
        {annio:2021,idedo:'1-31',total:2588},
        {annio:2021,idedo:'1-32',total:395},
        {annio:2021,idedo:'1-4',total:5116},
        {annio:2021,idedo:'1-5',total:474},
        {annio:2021,idedo:'1-6',total:273},
        {annio:2021,idedo:'1-7',total:5916},
        {annio:2021,idedo:'1-8',total:2580},
        {annio:2021,idedo:'1-9',total:78}
    ]
    let filtro=data.find(item => item.annio==annio && item.idedo===id)
    return filtro['total']
}

